import { ArrowLeft, Plus, Trash2, ChevronRight } from 'lucide-react'
import './AICreateCampaign.css'
import '../Pages.css'

export default function ScrapedDataConfirmation({ data, onChange, onBack, onNext }) {
  const updateField = (field, value) => {
    onChange({ ...data, [field]: value })
  }

  const updatePainPoint = (index, value) => {
    const updated = [...(data.painPoints || [])]
    updated[index] = value
    onChange({ ...data, painPoints: updated })
  }

  const addPainPoint = () => {
    onChange({ ...data, painPoints: [...(data.painPoints || []), ''] })
  }

  const removePainPoint = (index) => {
    const updated = (data.painPoints || []).filter((_, i) => i !== index)
    onChange({ ...data, painPoints: updated })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      {/* Header actions */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem' }}>
        <div>
          <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: 'var(--color-text-primary)' }}>
            Review Extracted Data
          </h3>
          <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', margin: '0.25rem 0 0' }}>
            Verify and edit the scraped company information, then continue to define your lead profile
          </p>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button onClick={onBack} className="btn btn-ghost">
            <ArrowLeft size={16} />
            Back
          </button>
          <button onClick={onNext} className="btn btn-primary">
            Continue
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      {/* Company Info Card */}
      <div className="card">
        <div className="card-header">
          <h3>Company Information</h3>
        </div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group">
              <label>Company Name</label>
              <input
                type="text"
                value={data.companyName || ''}
                onChange={(e) => updateField('companyName', e.target.value)}
                placeholder="e.g., Acme Corporation"
              />
            </div>
            <div className="form-group">
              <label>Industry</label>
              <input
                type="text"
                value={data.industry || ''}
                onChange={(e) => updateField('industry', e.target.value)}
                placeholder="e.g., B2B SaaS"
              />
            </div>
          </div>

          <div className="form-group" style={{ marginTop: '1rem' }}>
            <label>Value Proposition</label>
            <textarea
              value={data.valueProp || ''}
              onChange={(e) => updateField('valueProp', e.target.value)}
              placeholder="What core value does this company offer?"
              rows={3}
              style={{ resize: 'vertical' }}
            />
          </div>

          <div className="form-group" style={{ marginTop: '1rem' }}>
            <label>Target Audience</label>
            <input
              type="text"
              value={data.targetAudience || ''}
              onChange={(e) => updateField('targetAudience', e.target.value)}
              placeholder="e.g., Mid-market B2B sales teams"
            />
          </div>

          <div className="form-group" style={{ marginTop: '1rem' }}>
            <label>Company Description</label>
            <textarea
              value={data.description || ''}
              onChange={(e) => updateField('description', e.target.value)}
              placeholder="Brief company description..."
              rows={4}
              style={{ resize: 'vertical' }}
            />
          </div>
        </div>
      </div>

      {/* Pain Points Card */}
      <div className="card">
        <div className="card-header" style={{ justifyContent: 'space-between' }}>
          <h3>Pain Points the Company Solves</h3>
          <button
            onClick={addPainPoint}
            className="btn btn-ghost"
            style={{ fontSize: '0.8rem', padding: '0.375rem 0.75rem' }}
          >
            <Plus size={14} />
            Add
          </button>
        </div>
        <div className="card-body">
          {(data.painPoints || []).length === 0 ? (
            <p style={{ color: 'var(--color-text-muted)', fontSize: '0.875rem' }}>
              No pain points detected. Click "Add" to add one manually.
            </p>
          ) : (
            (data.painPoints || []).map((point, i) => (
              <div key={i} className="ai-pain-point-item">
                <input
                  type="text"
                  value={point}
                  onChange={(e) => updatePainPoint(i, e.target.value)}
                  placeholder={`Pain point ${i + 1}...`}
                />
                <button
                  onClick={() => removePainPoint(i)}
                  style={{
                    background: 'rgba(239, 68, 68, 0.08)',
                    border: '1px solid rgba(239, 68, 68, 0.15)',
                    color: '#ef4444',
                    borderRadius: 'var(--radius-md)',
                    padding: '0.45rem 0.6rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
